import { getFormattedLength } from "./getFormattedLength";

const buildVersionAdId = (adAgencyId: number, expectedDeliveryNumber: number, requiredLength: number) => {
    return `${adAgencyId}-${expectedDeliveryNumber}-${getFormattedLength(requiredLength)}`;;
};

export default buildVersionAdId;